import { Suspense } from "react";
import "./App.scss";
// import { HashRouter as Router } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import idID from "antd/locale/id_ID";
import "dayjs/locale/zh-cn";
import WabaCaptchaRouter from "./router/wabaCaptchaRouter";

function App() {
  const local = localStorage.getItem("local")!;
  return (
    <Router>
      <Suspense>
        <ConfigProvider
          locale={local === "en-us" ? enUS : local === "id-id" ? idID : enUS}
          theme={{
            token: {
              fontFamily: "Montserrat",
            },
          }}
        >
          <WabaCaptchaRouter />
          {/* </I18nextProvider> */}
        </ConfigProvider>
      </Suspense>
    </Router>
  );
}

export default App;
